import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Select,
  notification,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { API } from "../../../config/Api";
import { DELETE, POST } from "../../../utils/apiRequest";
import HorizontalLineLoader from "../../components/loader";
import DevicesTable from "./datatable";
import { useSelector } from "react-redux";

function ActivityDevicesSettings() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [meta, setMeta] = useState<any>({});
  
  useEffect(() => {
    getActiveDevices();
  }, [page, take]);

  const getActiveDevices = async () => {
    try {
      setIsLoading2(true);
      let obj = {
        page: page,
        take: take,
      };
      let api = API.GET_ACTIVE_ADMIN_DEVICES;
      const response: any = await POST(api, obj);
      if (response?.status) {
        setData(response?.data);
        setIsLoading(false);
        setMeta(response?.meta);
      } else {
        setData([]);
        setIsLoading(false);
      }
      setIsLoading2(false);
    } catch (err) {
      setIsLoading(false);
      setIsLoading2(false);
    }
  };


  return (
    <>
      <Card>
        <br />
        {isLoading2 ? <HorizontalLineLoader /> : null}
        <div className="screenBox">
          <DevicesTable
            data={data}
            meta={meta}
            onPageChange={(page: number, pageSize: number) => {
              setIsLoading2(true);
              setPage(page);
              setTake(pageSize);
            }}
          />
        </div>
      </Card>
    </>
  );
}

export default ActivityDevicesSettings;
